var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navpad whitebackground"},[_vm._v(" Hi 👋 "),_c('span',[_c('b',[_vm._v(_vm._s(_vm.employeeprofile.name))])]),_c('br'),_vm._v(" "+_vm._s(_vm.employeeprofile.company)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }